import { render } from "./IconWhatsUp.vue?vue&type=template&id=59f4676a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconWhatsUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59f4676a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59f4676a', __exports__)) {
    api.reload('59f4676a', __exports__)
  }
  
  module.hot.accept("./IconWhatsUp.vue?vue&type=template&id=59f4676a", () => {
    api.rerender('59f4676a', render)
  })

}


export default __exports__